import api from "@/lib/api";
import { NUM, TRY } from "@/lib/format";

export const fetchHistory = (params) => api.get("/products/purchase-history", { params }).then((r) => r.data);

const ymd = (d) => d.toLocaleDateString("sv-SE");
const monthsAgo = (n) => { const d = new Date(); const day = d.getDate(); d.setDate(1); d.setMonth(d.getMonth() - n); d.setDate(Math.min(day, new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate())); return d; };
// Alış geçmişi dönem süzgeci → [başlangıç, bitiş] (YYYY-MM-DD, yerel tarih)
export const PERIODS = [["all", "Tümü"], ["1m", "Aylık"], ["3m", "3 Aylık"], ["6m", "6 Aylık"], ["1y", "Yıllık"], ["ytd", "Bu Yıl"], ["custom", "Tarih Seç"]];
export const periodRange = ({ period, from, to }) => {
  if (period === "custom") return [from || "", to || ""];
  const months = { "1m": 1, "3m": 3, "6m": 6, "1y": 12 }[period];
  if (months) return [ymd(monthsAgo(months)), ""];
  if (period === "ytd") return [`${new Date().getFullYear()}-01-01`, ""];
  return ["", ""];
};
export const periodParams = (p) => { const [start, end] = periodRange(p); return { ...(start && { start }), ...(end && { end }) }; };
export const money = (v, cur) => (cur && !["TRY", "TL"].includes(cur) ? `${NUM(v)} ${cur}` : TRY(v));
export const supKey = (r) => r.vkn || (r.supplier || "").toLocaleUpperCase("tr") || "-";
export const valid = (rows) => rows.filter((r) => r.status !== "red");

/** En yeniden eskiye sıralı satırlar → her satıra aynı ürünün bir önceki alışına göre net fiyat değişimi (%). */
export function withTrend(rows) {
  const older = {};
  const out = new Array(rows.length);
  for (let i = rows.length - 1; i >= 0; i--) {
    const r = rows[i];
    const k = `${r.pkey}|${r.currency}`;
    const prev = older[k];
    out[i] = { ...r, trend: prev && prev.net_unit > 0 ? ((r.net_unit - prev.net_unit) / prev.net_unit) * 100 : null };
    if (r.status !== "red") older[k] = r;
  }
  return out;
}

/** Tedarikçi özetleri (reddedilen faturalar hariç), son alışı en yeni olan önce. */
export function supplierStats(rows) {
  const m = {};
  valid(rows).forEach((r) => {
    const k = supKey(r);
    const s = m[k] || (m[k] = { key: k, supplier: r.supplier, vkn: r.vkn, lines: 0, inv: new Set(), qty: 0, units: new Set(), last: r, min: r.net_unit, max: r.net_unit });
    if ((r.date || "") > (s.last.date || "")) s.last = r;
    s.lines += 1;
    s.inv.add(r.belge_no);
    s.qty += r.quantity;
    s.units.add(r.unit);
    s.min = Math.min(s.min, r.net_unit);
    s.max = Math.max(s.max, r.net_unit);
  });
  return Object.values(m).sort((a, b) => (b.last.date || "").localeCompare(a.last.date || ""));
}

/** Özet kartları için toplamlar. */
export function kpis(rows) {
  const v = valid(rows);
  if (!v.length) return null;
  const last = v.reduce((a, r) => ((r.date || "") > (a.date || "") ? r : a), v[0]);
  const same = v.filter((r) => r.currency === last.currency);
  const units = [...new Set(v.map((r) => r.unit))];
  const qty = v.reduce((s, r) => s + r.quantity, 0);
  const sq = same.reduce((s, r) => s + r.quantity, 0);
  return {
    last, units, qty,
    invoices: new Set(v.map((r) => `${supKey(r)}|${r.belge_no}`)).size,
    suppliers: new Set(v.map(supKey)).size,
    min: Math.min(...same.map((r) => r.net_unit)), max: Math.max(...same.map((r) => r.net_unit)),
    avg: sq > 0 ? same.reduce((s, r) => s + r.net_unit * r.quantity, 0) / sq : 0,
  };
}
